import "./style.scss";

import { createApp, type App } from "vue";

import { getAdminEmail } from "@client/elements/admin";

import Client from "@client/Client.vue";

import type { ShippingRate } from "@/types";

const INNOSEND_ID = "innosend" as const;
const INNOSEND_SELECTOR = `#${INNOSEND_ID}` as const;

let app: App;

const events = ["updated_checkout", "cart_page_refreshed"];

const { select, subscribe } = window.wp.data;

function init() {
	try {
		if (select("wc/store/cart")) {
			const shippingRates = select("wc/store/cart")
				.getShippingRates()[0]
				?.shipping_rates.filter(({ method_id }: ShippingRate) => method_id === INNOSEND_ID);

			if (!shippingRates?.[0]?.selected) {
				if (app) {
					app.unmount();
				}
				return;
			}
		}

		const appElement = document.getElementById(INNOSEND_ID);
		if (!appElement) return;

		if (app) {
			app.unmount();
		}

		app = createApp(Client);
		app.mount(INNOSEND_SELECTOR);
	} catch (error) {
		const appElement = document.getElementById(INNOSEND_ID);
		if (!appElement) return;

		if (app) {
			app.unmount();
		}

		app = createApp(Client);
		app.mount(INNOSEND_SELECTOR);
	}
}

const observer = new MutationObserver((mutations, obs) => {
	const element = document.getElementById(INNOSEND_ID);
	if (element) {
		init();
		obs.disconnect();
	}
});

if (!document.getElementById(INNOSEND_ID)) {
	observer.observe(document.body, { childList: true, subtree: true });
} else {
	init();
	events.forEach((event) => jQuery(document.body).on(event, init));
}

document.addEventListener("DOMContentLoaded", () => {
	init();
	events.forEach((event) => jQuery(document.body).on(event, init));
});

if (window.wp?.data) {
	subscribe(() => {
		const shippingRates = select("wc/store/cart").getShippingRates()[0]?.shipping_rates;

		if (shippingRates) {
			init();
		}
	});
}

getAdminEmail();
